/* ThoBae wishlist — localStorage, no app, no login */
(function () {
  var KEY = 'thobae_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCount();
    document.dispatchEvent(new CustomEvent('thobae:wishlist:change', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return list.indexOf(handle) !== -1;
  }
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // reflect saved state on any heart buttons present
  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var on = has(handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var on = toggle(handle);
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  // expose for the favourites page
  window.ThobaeWishlist = { read: read, has: has, toggle: toggle, remove: function (h) {
    var list = read(); var i = list.indexOf(h); if (i !== -1) { list.splice(i, 1); write(list); }
  }};

  document.addEventListener('DOMContentLoaded', function () { syncButtons(); updateCount(); });
  document.addEventListener('shopify:section:load', function (e) { syncButtons(e.target); updateCount(); });
})();